/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SsoimageStatusesQueryResponse,
  GetApiV1SsoimageStatuses401,
  GetApiV1SsoimageStatuses500,
} from "../../types/SSOImageController/GetApiV1SsoimageStatuses.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SsoimageStatuses } from "../../clients/SSOImageController/getApiV1SsoimageStatuses.ts";

export const getApiV1SsoimageStatusesQueryKey = () =>
  [{ url: "/api/v1/ssoimage/statuses" }] as const;

export type GetApiV1SsoimageStatusesQueryKey = ReturnType<
  typeof getApiV1SsoimageStatusesQueryKey
>;

export function getApiV1SsoimageStatusesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SsoimageStatusesQueryKey();
  return queryOptions<
    GetApiV1SsoimageStatusesQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageStatuses401 | GetApiV1SsoimageStatuses500
    >,
    GetApiV1SsoimageStatusesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SsoimageStatuses({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os valores do enum ESSOImageStatus com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar status de imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/statuses}
 */
export function useGetApiV1SsoimageStatuses<
  TData = GetApiV1SsoimageStatusesQueryResponse,
  TQueryData = GetApiV1SsoimageStatusesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SsoimageStatusesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SsoimageStatusesQueryResponse,
        ResponseErrorConfig<
          GetApiV1SsoimageStatuses401 | GetApiV1SsoimageStatuses500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1SsoimageStatusesQueryKey();

  const query = useQuery(
    {
      ...getApiV1SsoimageStatusesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1SsoimageStatuses401 | GetApiV1SsoimageStatuses500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
